<footer class="bg-base-200">
  <div class="container mx-auto px-4 pt-16 pb-6 sm:px-6 lg:px-8 max-w-screen-xl">
    <!-- Top row: logo + powered by -->
    <div class="flex items-center justify-between">
      <a [routerLink]="AppRoutes.home()" class="flex-shrink-0">
        @if (ctx.charity?.logo?.color) {
          <img
            [src]="ctx.charity.logo.color"
            [alt]="ctx.charity.name"
            class="h-10 w-auto select-none"
          />
        }
      </a>

      @if (!ctx.charity?.enableIncognito) {
        <a [href]="NavLinks.givebriteHome.path" target="_blank" rel="noopener noreferrer">
          <ui-button
            variant="ghost"
            extraClass="gap-1 px-0 text-base-content/60 hover:bg-transparent hover:text-base-content"
          >
            <img
              src="assets/powered-by-givebrite.png"
              [alt]="NavLinks.givebriteHome.label"
              class="h-6 w-auto"
            />
          </ui-button>
        </a>
      }
    </div>

    <!-- Bottom row: links + copyright -->
    <div class="border-t border-base-300 mt-12 pt-6">
      <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 text-sm">
        <nav class="flex gap-4">
          <a [routerLink]="NavLinks.terms.path" class="link link-hover">{{
            NavLinks.terms.label
          }}</a>
          <span class="text-base-content/30">&middot;</span>
          <a [routerLink]="NavLinks.privacy.path" class="link link-hover">{{
            NavLinks.privacy.label
          }}</a>
          <span class="text-base-content/30">&middot;</span>
          <a [routerLink]="NavLinks.support.path" class="link link-hover">{{
            NavLinks.support.label
          }}</a>
        </nav>

        <div class="text-base-content/60">
          <span>&copy; {{ ctx.charity?.name }} {{ year }}</span>
          @if (ctx.charity?.registrationNumber) {
            <span class="block sm:inline sm:ml-2">
              Charity Number: {{ ctx.charity.registrationNumber }}
            </span>
          }
        </div>
      </div>
    </div>
  </div>
</footer>
